import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Overview } from '../../abstract/Overview';
import { DataServiceModel, Model } from '../../interfaces/Model';
import { CommonModule } from '@angular/common';
import { CLOSE, MODELS_OVERVIEW, RESTORE_HERE, RESTORE_NEW_TAB, SCHEMA_OVERVIEW } from '../../shared/strings';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ServerResponse } from '../../interfaces/ServerResponse';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MainComponent } from '../../pages/main/main.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTreeModule } from '@angular/material/tree';
import { Neo4jCreatorComponent } from '../tab-models/neo4j-creator/neo4j-creator.component';
import { SharedService } from '../../services/shared.service';
import { INeo4jData } from '../../interfaces/INeo4jData';
import { INeo4j } from '../../interfaces/Neo4j';
import { Importer } from '../../clases/Importer';
import { ImportEnum } from '../../enums/Import';
import { ViewsTree } from '../../interfaces/ViewsTree';
import { CdkMenuModule } from '@angular/cdk/menu';
import { ViewFromServer } from '../../interfaces/ViewFromServer';
import { ISaveView } from '../../interfaces/SaveView';
import { convertIntoImporterType } from '../../utils/utils';
import { ModelsTreeComponent } from '../models-tree/models-tree.component';

@Component({
  selector: 'models-overview',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatTreeModule,
    CdkMenuModule,
    ModelsTreeComponent
  ],
  templateUrl: './models-overview.component.html',
  styleUrl: './models-overview.component.scss'
})
export class ModelsOverviewComponent extends Overview implements OnInit {

  MODELS_OVERVIEW = MODELS_OVERVIEW;
  RESTORE_HERE = RESTORE_HERE;
  RESTORE_NEW_TAB = RESTORE_NEW_TAB;
  CLOSE = CLOSE;

  @Input() mainComponent!: MainComponent;

  @ViewChild(ModelsTreeComponent, {static: false}) modelTree!: ModelsTreeComponent;

  isLoading: boolean = false;

  // ds_models: ViewsTree[] = [];

  // // Accessor for children to use with MatTree's childrenAccessor API
  // readonly childrenAccessor = (node: ViewsTree) => node.children ?? [];
  // hasChild = (_: number, node: ViewsTree) => !!node.children && node.children.length > 0;

  currentSelected!: ViewFromServer;

  constructor(private beNeo4jService: BeNeo4jService, private sharedService: SharedService, private cdr: ChangeDetectorRef){super();}

  ngOnInit(): void {}

  override toggle(): void {
    super.toggle();
    if(this.isOverviewActive) this.getModels();
  }

  getModels(){
    this.isLoading = true;
    this.beNeo4jService.getViewsStruct().subscribe({
      next: (res: ServerResponse<ViewsTree>)=>{
        this.isLoading = false;
        // this.ds_models = res.result;
        this.cdr.detectChanges();
        this.modelTree.ds_models = res.result;
      },
      error: (error)=>{
        this.isLoading = false;
      }
    });
  }

  onModelSelected = (node: ViewsTree)=>{
    if(node.view){
      this.currentSelected = node.view;
    }
  }

  onRestore(importType: string) {
    if (!this.currentSelected) return;
    let type = convertIntoImporterType(importType);
    let savedView = JSON.parse(this.currentSelected!.file_content as string) as ISaveView;
    let dataservice = this.sharedService.data_services!.find((service) => service.data_service_id === savedView.data_service_id);
    let neo4j_data = {
      dataService: dataservice,
      DBlabels: [],
      DBrelations: [],
      hierarchy: [],
      schemaTree: []
    } as INeo4jData;
    let neo4j = {
      connection: neo4j_data,
      name_value: savedView.name_value,
      containers: JSON.parse(JSON.stringify(savedView.containers)),
      model_UUID: this.currentSelected.model_UUID,
      hierarchy: this.currentSelected.hierarchy
    } as INeo4j;
    //send to main class
    this.mainComponent.onImportAction(new Importer(neo4j, type, this.currentSelected));
  }

  isSameDataService(): boolean{
    if(!this.currentSelected)return false;
    let connection = this.currentSelected.file_content as ISaveView;
    return connection.data_service_id === this.sharedService.data_service?.data_service_id
  }
}
